import { send } from '@actual-app/core/platform/client/connection';

import { sync } from '#app/appSlice';
import { loadAllFiles } from '#budgetfiles/budgetfilesSlice';
import { trasladarPortada } from '#components/manager/puerto/portada';
import { loadPrefs } from '#prefs/prefsSlice';
import type { AppDispatch } from '#redux/store';

/**
 * Sube a la nube, cifrado, el barco abierto (`id`) y deja la app al día: la
 * portada pasa a su número de la nube, se recargan las prefs y la lista del
 * puerto, y se sincroniza.
 * Sin cofre abierto o sin conexión no sube nada y devuelve `error`.
 * Lo usan la subida automática y el botón de Ajustes → «Amarre».
 */
export async function subirBarco(
  dispatch: AppDispatch,
  id: string | undefined,
) {
  const r = await send('rumbo-subir-a-la-nube', { id });
  if (r.error) {
    return r;
  }
  const prefs = await send('load-prefs');
  if (id && prefs?.cloudFileId) {
    trasladarPortada(id, prefs.cloudFileId);
  }
  await dispatch(loadPrefs());
  void dispatch(loadAllFiles());
  void dispatch(sync());
  return r;
}
